import { useEffect, useRef } from 'react';

/**
 * The browser's own "leave site?" prompt on closing or reloading the tab
 * while `active`. Closing the tab ends its sessionStorage, and with it any
 * draft (shared/utils/drafts.js), so this is the last chance to keep it.
 */
export default function useUnloadWarning(active) {
    const activeRef = useRef(active);
    activeRef.current = active;

    useEffect(() => {
        const onBeforeUnload = (event) => {
            if (!activeRef.current) return;
            event.preventDefault();
            // Chrome and Edge show the prompt only when returnValue is set
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, []);
}
